export default __webpack_public_path__ + "static/media/023-soccer.a04b1e67.svg";